import React, { useState } from 'react';
import { InfoIcon } from 'lucide-react';
interface TooltipProps {
  content: string;
}
export function Tooltip({
  content
}: TooltipProps) {
  const [isVisible, setIsVisible] = useState(false);
  return <div className="relative inline-block ml-1" data-id="element-270">
      <button type="button" onMouseEnter={() => setIsVisible(true)} onMouseLeave={() => setIsVisible(false)} onFocus={() => setIsVisible(true)} onBlur={() => setIsVisible(false)} onClick={() => setIsVisible(!isVisible)} className="text-gray-500 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-1" aria-label="More information" data-id="element-271">
        <InfoIcon className="w-4 h-4" data-id="element-272" />
      </button>
      {isVisible && <div className="absolute z-10 w-64 max-w-[calc(100vw-2rem)] p-3 text-sm bg-gray-900 text-white bottom-full left-1/2 transform -translate-x-1/2 mb-2 shadow-lg rounded" data-id="element-273">
          {content}
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 -mt-1" data-id="element-274">
            <div className="border-8 border-transparent border-t-gray-900" data-id="element-275"></div>
          </div>
        </div>}
    </div>;
}